// Copyright 2026 Bitech.id. Licensed under the MIT License.

import type { BiwaveClient } from './client.js';

let currentClient: BiwaveClient | undefined;

/** Set by each runtime package's init() (node/hono/browser) after constructing its client. */
export function setCurrentClient(client: BiwaveClient): void {
  currentClient = client;
}

/**
 * Convenience accessor for adapters (e.g. @biwave/winston) that don't want to
 * thread an explicit client through every call site. Always prefer passing
 * an explicit client where one is naturally available — this exists for
 * cases where it isn't (e.g. a logger instance created far from init()).
 */
export function getCurrentClient(): BiwaveClient | undefined {
  return currentClient;
}
